import Vue from 'vue';
const EventBus = new Vue();
export default EventBus;


// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/lib/event-bus.js